/**
 * Value of `selectedReviewMemberAtom` when the user selects Action Center
 * from the review combobox.
 */
export const ASSISTANT_VIEW_SELECT_ID = 'action-center';
